import type { ReactNode } from 'react'

export const PhotosetStatusMessage = ({
	gap = 2,
	children
}: {
	gap?: 2 | 3
	children: ReactNode
}) => (
	<div
		className={`mx-auto mt-8 mb-6 flex w-[392px] flex-col items-center gap-${gap === 3 ? '3' : '2'} text-center`}
	>
		{children}
	</div>
)
